// Tried html-escaper and escape-html libraries from npm packages
// which don't work for us. Will be using following replacement for now
const getValidXml = (xml: string) => xml.replace(/&/g, '&amp;');

export default getValidXml;
